import React from 'react';
import Logo from '../../../../assets/images/training_logo.png';
import { Header, Burger } from '@mantine/core';
import { Link } from 'react-router-dom';
import FacilitatorHeaderActions from './FacilitatorHeaderActions';

const FacilitatorHeader = ({
  opened = false,
  setOpened = () => {},
  isMobileNav = false,
}) => {
  return (
    <Header height={{ base: 50, md: 70 }} p='md' style={{ zIndex: 3101 }}>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        {isMobileNav && (
          <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            size='sm'
            color='#575656'
            mr='xl'
          />
        )}
        <div className='flex items-center justify-between w-full h-full'>
          <Link
            to='/facilitator/home'
            aria-label='Go to home'
            className='h-full'
          >
            <img alt='Logo' src={Logo} className='h-full w-auto' />
          </Link>
          <div className='flex gap-3 items-center ml-auto'>
            {!isMobileNav && <FacilitatorHeaderActions />}
          </div>
        </div>
      </div>
    </Header>
  );
};

export default FacilitatorHeader;
